module.exports = __webpack_public_path__ + "ticket.png?c5f3f2a46c0371fe60b1ffc41adeb89a";